import { Component, inject, input, output } from '@angular/core';
import { SharedCommonModule } from '@shared/common.module';
import { EduOverlayMenuComponent } from '@atoms/overlay-menu/overlay-menu.component';
import { EduIconComponent, Icons } from '@atoms/icon/icon.component';
import { ThemeService } from '@shared/services/theme.service';

@Component({
  selector: 'edu-user-menu',
  templateUrl: './user-menu.component.html',
  imports: [SharedCommonModule, EduOverlayMenuComponent, EduIconComponent],
})
export class EduUserMenuComponent {
  readonly theme = inject(ThemeService);

  public isLoading = input<boolean>(false);
  public firstname = input<string | undefined>('');
  public lastname = input<string | undefined>('');
  public email = input<string | undefined>('');
  public avatarUrl = input<string | undefined>('');
  public logout = output<void>();

  public Icons = Icons;

  public handleLogout(): void {
    this.logout.emit();
  }

  public toggleTheme(): void {
    this.theme.toggle();
  }
}
